module.exports = __webpack_public_path__ + "static/media/ProximaNovaSemibold.6a386899.otf";